module.exports = __webpack_public_path__ + "87fd8ad70f260dba85c650deadb0bde4.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/14/selma_stories.jpg
// module id = 240
// module chunks = 0